module.exports = {
        srcSet: __webpack_public_path__ + "54524266f80d8dbe-600.webp"+" 600w"+","+__webpack_public_path__ + "671079f6fa15b085-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "54524266f80d8dbe-600.webp",width: 600,height: 300},{path: __webpack_public_path__ + "671079f6fa15b085-1000.webp",width: 1000,height: 500}],
        src: __webpack_public_path__ + "671079f6fa15b085-1000.webp",
        toString: function(){return __webpack_public_path__ + "671079f6fa15b085-1000.webp"},
        
        width: 1000,
        height: 500
      }